var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.source._id)+" | "+_vm._s(_vm.source.type)+" | "+_vm._s(_vm.source.balance)+_vm._s(_vm.source.status ? (" | " + (_vm.getStatusText(_vm.source.status))) : "")+_vm._s(_vm.source.transactionId ? (" | " + (_vm.source.transactionId)) : "")+_vm._s(_vm.source.createdAt
      ? (" | " + (_vm.$dayjs(_vm.source.createdAt).format("DD.MM.YYYY HH:mm:ss")))
      : "")+"\n  => "+_vm._s(_vm.source.cumulative)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f54b0b5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Users/components/BalanceHistory/HistoryItem.vue
// module id = null
// module chunks = 